import React, { useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Modal,
} from "reactstrap";
import classnames from "classnames";
import { CircularProgressbarWithChildren } from "react-circular-progressbar";

const CodeSnippetModal = ({
  isModalActive,
  onToggleModal,
  codeSnippet,
  sectionScore,
}) => {
  const tog_center = (e) => {
    onToggleModal(!isModalActive);
  };
  const [customActiveTab, setcustomActiveTab] = useState("1");

  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };

  console.log("codingquestiondetial", codeSnippet);
  return (
    <React.Fragment>
      <Col lg={6}>
        <Card>
          <CardBody>
            <div>
              <Modal
                isOpen={isModalActive}
                toggle={() => {
                  tog_center();
                }}
                centered={true}
                className="modal-xl"
                style={{ zoom: "80%" }}
              >
                <div className="px-4 py-4">
                  <h5 className="text-primary">
                    Coding Assessment Details&nbsp;&nbsp;
                    <span className="font-size-12 text-muted mt-2">
                      ⓘ Present comprehensive details Coding Test.
                    </span>
                  </h5>

                  <Nav
                    tabs
                    className="mt-4 nav-tabs-custom nav-justified-start"
                  >
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: customActiveTab === "1",
                        })}
                        onClick={() => {
                          toggleCustom("1");
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="far fa-user"></i>
                        </span>
                        <span className="d-none d-sm-block">Use Case</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: customActiveTab === "2",
                        })}
                        onClick={() => {
                          toggleCustom("2");
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="fas fa-home"></i>
                        </span>
                        <span className="d-none d-sm-block">Evaluation</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: customActiveTab === "3",
                          "bg-light-subtle": customActiveTab === "3",
                        })}
                        onClick={() => {
                          toggleCustom("3");
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="fas fa-home"></i>
                        </span>
                        <span className="d-none d-sm-block">Code Snippet</span>
                      </NavLink>
                    </NavItem>
                  </Nav>

                  <TabContent activeTab={customActiveTab} className="p-2">
                    <TabPane tabId="1">
                      <Row>
                        <Col sm="12">
                          <div className="">
                            <div className="card-body">
                              {/* Summary and Score */}
                              <div className="row">
                                <div className="col-sm order-2 order-sm-1">
                                  <div className="d-flex align-items-start mt-3 mt-sm-0">
                                    <div className="flex-grow-1">
                                      <div>
                                        <p className="font-size-14">
                                          {codeSnippet &&
                                            codeSnippet.code_result &&
                                            codeSnippet.code_result.summary}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* Hints */}
                              <div className="row mt-2">
                                <div className="col-sm order-2 order-sm-1">
                                  <div className="d-flex align-items-start mt-3 mt-sm-0">
                                    <div className="flex-grow-1">
                                      <div>
                                        <h5 className="font-size-16 mb-1">
                                          Hints
                                        </h5>

                                        <div className="d-flex flex-wrap align-items-start gap-2 gap-lg-3 text-muted font-size-13">
                                          <div>
                                            <i className="mdi mdi-circle-medium me-1 text-success align-middle" />
                                            {
                                              codeSnippet?.questionDetails
                                                ?.constraints
                                            }
                                          </div>
                                        </div>
                                        {/* {codeSnippet?.questionDetails?.example &&
                                          codeSnippet?.questionDetails?.example.map(
                                            (hint, index) => (
                                              <div key={index} className="d-flex flex-wrap align-items-start gap-2 gap-lg-3 text-muted font-size-13">
                                                <div>
                                                  <i className="mdi mdi-circle-medium me-1 text-success align-middle" />
                                                  {hint?.input}
                                                </div>
                                              </div>
                                            ),
                                          )} */}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* Recommendation */}
                              <div className="row mt-4">
                                <div className="col-sm order-2 order-sm-1">
                                  <div className="d-flex align-items-start mt-3 mt-sm-0">
                                    <div className="flex-grow-1">
                                      <div>
                                        <h5 className="font-size-16 mb-1">
                                          Recommendations
                                        </h5>
                                        {codeSnippet?.questionDetails
                                          ?.example &&
                                          codeSnippet?.questionDetails?.example.map(
                                            (recommendation, index) => (
                                              <>
                                                <div
                                                  key={index}
                                                  className="align-items-start gap-2 gap-lg-3 text-muted font-size-13"
                                                >
                                                  <div className="d-flex mb-2">
                                                    <div>
                                                      <h6 className="m-0">
                                                        Example:
                                                      </h6>
                                                    </div>
                                                    <div className="mx-3">
                                                      {
                                                        recommendation?.explanation
                                                      }
                                                    </div>
                                                  </div>

                                                  <div className="d-flex mb-2">
                                                    <div>
                                                      <h6 className="m-0">
                                                        Input:
                                                      </h6>
                                                    </div>
                                                    <div className="mx-3">
                                                      {recommendation?.input}
                                                    </div>
                                                  </div>

                                                  <div className="d-flex mb-4">
                                                    <div>
                                                      <h6 className="m-0">
                                                        Output:
                                                      </h6>
                                                    </div>
                                                    <div className="mx-3">
                                                      {recommendation?.output}
                                                    </div>
                                                  </div>
                                                </div>
                                              </>
                                            )
                                          )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* end card body */}
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tabId="2">
                      <Row>
                        <Col sm="12">
                          <div className="">
                            <div className="card-body">
                              {/* Summary and Score */}
                              {/* <div className="row">
                                <div className="col-sm order-2 order-sm-1">
                                  <div className="d-flex align-items-start mt-3 mt-sm-0">
                                    <div className="flex-grow-1">
                                      <div>
                                        <p className="font-size-14">
                                          {codeSnippet &&
                                            codeSnippet.code_result &&
                                            codeSnippet.code_result.summary}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-sm-auto order-1 order-sm-2">
                                  <div className="d-flex align-items-start justify-content-end gap-2">
                                    <div
                                      className=""
                                      style={{ width: "60px", height: "50px" }}
                                    >
                                      <CircularProgressbarWithChildren
                                        styles={{
                                          root: {}, // Adjust these values
                                          path: {
                                            stroke: "#5156be",
                                            strokeLinecap: "round",
                                            transition:
                                              "stroke-dashoffset 0.5s ease 0s",
                                            transform: "rotate(0.25turn)",
                                            transformOrigin: "center center",
                                            pathColor: "#74788d",
                                          },
                                          trail: {
                                            stroke: "#d6d6d6",
                                            strokeLinecap: "round",
                                            transform: "rotate(0.25turn)",
                                            transformOrigin: "center center",
                                          },
                                        }}
                                        value={
                                          sectionScore &&
                                          (
                                            (sectionScore?.Coding?.score /
                                              100) *
                                            100
                                          ).toFixed(0)
                                        }
                                      >
                                        <div style={{ fontSize: 12 }}>
                                          <strong>
                                            {sectionScore?.Coding?.score}
                                            %
                                          </strong>
                                        </div>
                                      </CircularProgressbarWithChildren>
                                    </div>
                                  </div>
                                </div>
                              </div> */}
                              {/* Reasoning */}
                              {/* <div className="row mt-2">
                                <div className="col-sm order-2 order-sm-1">
                                  <div className="d-flex align-items-start mt-3 mt-sm-0">
                                    <div className="flex-grow-1">
                                      <div>
                                        <h5 className="font-size-16 mb-1">
                                          Reasoning
                                        </h5>
                                        {codeSnippet &&
                                          codeSnippet.code_result &&
                                          codeSnippet.code_result.reasoning.map(
                                            (code, index) => (
                                              <div
                                                key={index}
                                                className="d-flex flex-wrap align-items-start gap-2 gap-lg-3 text-muted font-size-13"
                                              >
                                                <div>
                                                  <i className="mdi mdi-circle-medium me-1 text-success align-middle" />
                                                  {code}
                                                </div>
                                              </div>
                                            )
                                          )}

                                        
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div> */}
                              {/* Evaluation */}
                              <div className="row mt-4">
                                <div className="col-sm order-2 order-sm-1">
                                  <div className="d-flex align-items-start mt-3 mt-sm-0">
                                    <div className="flex-grow-1">
                                      <div>
                                        {/* <h5 className="font-size-16 mb-1">
                                          Evaluation
                                        </h5> */}
                                        <p className="m-0">
                                          <strong>Correctness:</strong>
                                        </p>
                                        <p className="m-0 text-muted">
                                          <strong>Score:</strong>{" "}
                                          {codeSnippet && codeSnippet.executionResult
                                            ? codeSnippet.executionResult.correctness
                                                ?.score
                                            : "-"}
                                        </p>
                                        <p className="m-0 text-muted mb-3">
                                          <strong>Feedback:</strong>{" "}
                                          {codeSnippet && codeSnippet.executionResult
                                            ? codeSnippet.executionResult.correctness
                                                ?.explanation
                                            : "-"}
                                        </p>

                                        <p className="m-0">
                                          <strong>Readability:</strong>
                                        </p>
                                        <p className="m-0 text-muted">
                                          <strong>Score:</strong>{" "}
                                          {codeSnippet && codeSnippet.executionResult
                                            ? codeSnippet.executionResult.readability
                                                ?.score
                                            : "-"}
                                        </p>
                                        <p className="m-0 text-muted mb-3">
                                          <strong>Feedback:</strong>{" "}
                                          {codeSnippet && codeSnippet.executionResult
                                            ? codeSnippet.executionResult.readability
                                                ?.explanation
                                            : "-"}
                                        </p>

                                        <p className="m-0">
                                          <strong>Efficiency:</strong>
                                        </p>
                                        <p className="m-0 text-muted">
                                          <strong>Score:</strong>{" "}
                                          {codeSnippet && codeSnippet.executionResult
                                            ? codeSnippet.executionResult.efficiency
                                                ?.score
                                            : "-"}
                                        </p>
                                        <p className="m-0 text-muted mb-3">
                                          <strong>Feedback:</strong>{" "}
                                          {codeSnippet && codeSnippet.executionResult
                                            ? codeSnippet.executionResult.efficiency
                                                ?.explanation
                                            : "-"}
                                        </p>

                                        <p className="m-0">
                                          <strong>Robustness:</strong>
                                        </p>
                                        <p className="m-0 text-muted">
                                          <strong>Score:</strong>{" "}
                                          {codeSnippet && codeSnippet.executionResult
                                            ? codeSnippet.executionResult.robustness
                                                ?.score
                                            : "-"}
                                        </p>
                                        <p className="m-0 text-muted mb-3">
                                          <strong>Feedback:</strong>{" "}
                                          {codeSnippet && codeSnippet.executionResult
                                            ? codeSnippet.executionResult.robustness
                                                ?.explanation
                                            : "-"}
                                        </p>

                                        <p className="m-0">
                                          <strong>Best Practices:</strong>
                                        </p>
                                        <p className="m-0 text-muted">
                                          <strong>Score:</strong>{" "}
                                          {codeSnippet && codeSnippet.executionResult
                                            ? codeSnippet.executionResult.bestPractices
                                                ?.score
                                            : "-"}
                                        </p>
                                        <p className="m-0 text-muted mb-3">
                                          <strong>Feedback:</strong>{" "}
                                          {codeSnippet && codeSnippet.executionResult
                                            ? codeSnippet.executionResult.bestPractices
                                                ?.explanation
                                            : "-"}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* end card body */}
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tabId="3">
                      <Row>
                        <Col sm="12">
                          {/* <CardText className="mb-0"> */}
                          {/* <div className="modal-header">
                  <h5 className="modal-title mt-0">Code Snippet</h5>
                </div> */}
                          {/* <div className="modal-body"> */}
                          <pre className="bg-light p-4">
                            <code className="">{codeSnippet?.userCode}</code>
                          </pre>

                          {/* </div> */}
                          {/* </CardText> */}
                        </Col>
                      </Row>
                    </TabPane>
                  </TabContent>
                  {/* </CardBody>
                  </Card> */}
                </div>
              </Modal>
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default CodeSnippetModal;
